/**
 * Service worker registration and update handling.
 */
import { registerSW } from "virtual:pwa-register";

export function registerServiceWorker(onUpdateReady: () => void): () => void {
  if (!("serviceWorker" in navigator)) return () => undefined;

  const updateSW = registerSW({
    onNeedRefresh: onUpdateReady,
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      // Pick up a new deploy when the app is reopened from the home screen.
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") void registration.update();
      });
    },
  });

  return () => void updateSW(true);
}

/**
 * Ask the browser to retry the outbox once it is back online. Chromium only;
 * elsewhere the app's own online/visibility listeners cover it.
 */
export async function requestOutboxSync(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;
  try {
    const registration = await navigator.serviceWorker.ready;
    const sync = (registration as ServiceWorkerRegistration & {
      sync?: { register: (tag: string) => Promise<void> };
    }).sync;
    await sync?.register("flush-outbox");
  } catch {
    // Background Sync unavailable (Safari) or permission denied — not fatal.
  }
}
